import * as React from 'react';
import { AutoComplete, type AutoCompleteProps } from 'antd';
import * as Store from '../store';
import SelectorEmpty from './SelectorEmpty';
import DimensionBetaLabel from '@src/components/dimension-panel-hz/dimensionSelectorPopup/DimensionBetaLabel';

export interface DimensionSelectorProps extends AutoCompleteProps {
  disableFilterFirstRender?: boolean;
}

const DimensionSelector = (props: DimensionSelectorProps) => {
  const { defaultValue, disableFilterFirstRender = false, ...params } = props;
  const [disableOptionFilter, setDisableOptionFilter] = React.useState(disableFilterFirstRender);
  const metadata = Store.useFilterMeta();
  const dimensionOptions = React.useMemo(() => {
    return metadata.dimensions
      .map((it) => ({
        label: it.name,
        options: it.fields
          .map((item) => ({
            label: item.name,
            value: item.value,
            key: `${item.value}-${item.name}`,
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      }))
      .filter((it) => it.label !== 'Tag' && it.options.length);
  }, [metadata]);

  return (
    <AutoComplete
      {...params}
      autoFocus
      defaultOpen
      placeholder={defaultValue || 'Search by dimension name'}
      options={dimensionOptions}
      notFoundContent={<SelectorEmpty />}
      optionRender={(option) => (
        <DimensionBetaLabel
          name={typeof option.label === 'string' ? option.label : ''}
          groupBy={String(option.value ?? '')}
        />
      )}
      filterOption={
        !disableOptionFilter &&
        ((inputValue, option) =>
          option?.label?.toString().toLowerCase().includes(inputValue.toLowerCase()) ?? false)
      }
      onSearch={() => {
        setDisableOptionFilter(false);
      }}
    />
  );
};

export default React.memo(DimensionSelector);
